/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TopBar_viewer = {
    readonly isNotificationsEnabled: boolean | null;
    readonly isFavoritesEnabled: boolean | null;
    readonly isCartEnabled: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_viewer" | "CartNav_viewer" | "Likes_viewer" | "Notifications_viewer" | "Notifications_initialViewer" | "SearchBar_viewer">;
    readonly " $refType": "TopBar_viewer";
};
export type TopBar_viewer$data = TopBar_viewer;
export type TopBar_viewer$key = {
    readonly " $data"?: TopBar_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"TopBar_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TopBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "hasSessionCountryCode",
      "type": "Boolean!",
      "defaultValue": false
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isNotificationsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NOTIFICATIONS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isCartEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CART"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CART\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Likes_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "hasSessionCountryCode",
          "variableName": "hasSessionCountryCode"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c5aeccc2bbc21862e2c2a94ff7e2b73f';
export default node;
